// App.js
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import 'flowbite';
import HomePage from './pages/Home/HomePage';
import RentalHomePage from './pages/Rentals/RentalHomePage';
import SellHomePage from './pages/Sell/SellHomePage';
import RentalDetailPage from './pages/Rentals/RentalDetailPage';
import LoginPage from './pages/Login/LoginPage';
import SGLoopHomePage from './pages/SGLoop/SGLoopHomePage';
import ProfileHomePage from './pages/Profile/ProfileHomePage';
import TermsPage from './pages/FooterPages/TermsPage';
import PrivacyPage from './pages/FooterPages/PrivacyPage';
import SellDetailPage from './pages/Sell/SellDetailPage';
import ServiceDetailPage from './pages/Services/ServicesDetailPage'
import ServicesHomePage from './pages/Services/ServicesHomePage'
import { AuthProvider } from "./context/AuthContext"
import ProtectedRoute from './utils/ProtectedRoute';
import FormsPage from './pages/Forms/FormsPage';
import LandingPage from './pages/Mentorship/LandingPage';
import HomePageCopy from './pages/Home/HomePageNew';
import NextloopServicesLandingPage from './pages/Services/NextloopServicesLandingPage';

function App() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <AuthProvider>
      <Routes key={location.pathname} location={location}>
        <Route path="/*" element={<HomePageCopy/>} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/rent" element={<RentalHomePage />} />
        <Route path="/rent/:id" element={<RentalDetailPage />} />
        <Route path="/sell" element={<SellHomePage />} />
        <Route path="/sell/:id" element={<SellDetailPage />} />
        <Route path="/services/" element={<ServicesHomePage />} />
        <Route path="/services/:id" element={<ServiceDetailPage />} />
        <Route path="/SGLoop" element={<SGLoopHomePage />} />
        <Route path="/profile" element={
          <ProtectedRoute><ProfileHomePage /></ProtectedRoute>
        } />
        <Route path="/forms/preview" element={<FormsPage preview={true} />} />
        <Route path="/forms/:id" element={<FormsPage preview={false} />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPage />} />
        <Route path='/spotlight/gateway' element={<LandingPage/>}></Route>
        <Route path="/spotlight/gateway/events/:slug" element={<LandingPage />} />
        <Route path='/nextloop-services' element={<NextloopServicesLandingPage/>}/>
      </Routes>
      </AuthProvider>
    </AnimatePresence>
  );
}

export default App;
